export default __webpack_public_path__ + "static/media/img_10.802d77c4.jpg";